import sidebar from '@/config/sidebars/adminHubspot'
import createVueApp from '@/common/createApp'

Styxie.Initializers.AdminHubspot = {
  show: async(props) => {
    const { default: Dashboard } = await import('@/vue_widgets/admin/hubspot/dashboard/index.vue')
    createVueApp(Dashboard, { props, sidebar })
  }
}
